module.exports = __webpack_public_path__ + "./fonts/DefaultThumbnail.20fba7cb12982ca87561cf9602c5a521.svg";